export default "__VITE_ASSET__CDvN5CHT__"